import React, { useContext } from 'react';
import Heading from '../../components/Typography/Heading/Heading';
import { rolloverGuideFAQ } from './utils';
import styles from './styles.css';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../../components/Beacon/BeaconComponents';
import { isProd } from '../../config';

const FAQList = () => {
  return rolloverGuideFAQ.map(question => {
    return (
      <>
        <li key={question.question}>
          <div className="question">
            <span>{question.question}</span>
          </div>
          <div>
            <span>{question.answer}</span>
          </div>
        </li>
        <style jsx>{styles}</style>
      </>
    );
  });
};

const RolloverGuideScreen = ({ appState }) => {
  const context = useContext(FlowContext);
  const {
    store: {
      app: {
        customer: {
          name: { firstName = 'FIRST NAME', lastName = 'LAST NAME' }
        }
      },
      chosenInvestments,
      loadedData: { accounts = [] }
    }
  } = appState;

  const { back } = context;
  const fundNames = chosenInvestments.map(({ name }) => name);
  const submittedAccounts = accounts.map(({ accountNumber }) => accountNumber);
  const rolloverGuideTimeTradeLink = isProd()
    ? 'https://trpii.my.site.com/scheduler/s?params=So7zAAT2gkfg6rrCoCmOGlHXoFFd0zyqQpmGMrSpIc8UVJM0%2FTeNFkxqEE51TEgzJ7P031I6g21mUfyMdP7O3%2FXePm8rUh3qEA7loR35AlrooI1LRPajRINDeL0hSz7hx4yGUVlauQ7KtdIPmtxVgA%3D%3D&flowName=GenerateInvitation'
    : 'https://trpii--qual.sandbox.my.site.com/scheduler/s?params=UtNAvJnjFqQ7vFtSBHKMPZ1U3Rlq4tj8NfwuTKGsCisFbW4CcpqQoYrRQ4WxOeaSxMh%2BUYhnhXcjkBpN2J2FELBc%2FYWetYQuPOsI8k%2FjjThV1cfK51x2Ck%2FWOaaSUT6rCmaPJUcgpApBxlBUYE8qAA%3D%3D&flowName=GenerateInvitation';

  return (
    <>
      <div className="page-container">
        <div className="banner">
          <div className="container">
            <div className="header">
              <div className="page-label">
                <span>rollover guide</span>
              </div>
              <div className="title">
                <Heading text="Everything is all set up on our end." />
              </div>
              <div className="subtitle">
                <span>
                  Now, you just need to contact your current provider to request
                  the rollover so we can complete the process.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="container panels">
          <div className="panel-container">
            <div className="panel-title">
              <span>
                Be sure to provide the following details to your current
                provider:
              </span>
            </div>

            <div className="grouping">
              <div className="grouping-title">
                <span>Issuing a check</span>
              </div>

              <p>
                <span>Make check payable to T. Rowe Price FBO </span>
                <span>{firstName} </span>
                <span>{lastName}</span>
                <span> and send to:</span>
                <div>
                  T. Rowe Price
                  <br />
                  P.O. Box 17300
                  <br />
                  Baltimore, MD 21297-1300
                  <br />
                </div>
              </p>

              <p>
                <span>
                  Put your new T. Rowe Price account number(s) in the memo area
                  of the check.
                </span>
              </p>
            </div>

            <div className="grouping no-margin">
              <div className="grouping-title">
                <span>If using a bank transfer, wire proceeds to:</span>
              </div>

              <table className="bank-transfer-info">
                <tbody>
                  <tr>
                    <td>Receiving Bank:</td>
                    <td>Bank of New York, N.A. (New York)</td>
                  </tr>
                  <tr>
                    <td>Receiving Bank ABA#:</td>
                    <td>021000018</td>
                  </tr>
                  <tr>
                    <td>Beneficiary:</td>
                    <td>
                      <span>T. Rowe Price </span>
                      <span>
                        {fundNames && fundNames.length > 0
                          ? fundNames.join(', ')
                          : '(Please also provide your fund names(s) on this line)'}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Beneficiary Account:</td>
                    <td>8900624809</td>
                  </tr>
                  <tr>
                    <td>Beneficiary Information:</td>
                    <td>
                      <span>
                        {firstName} {lastName}{' '}
                        {submittedAccounts && submittedAccounts.length > 0
                          ? submittedAccounts.join(', ')
                          : '(Please also provide your account number(s) on this line)'}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="panel-container">
            <div className="panel-title">
              <span>
                In addition, ask the following questions of your current
                provider:
              </span>
            </div>

            <ul className="faq-list">
              <FAQList />
            </ul>
          </div>
        </div>

        <div className="help-container">
          <div className="container">
            <div className="help">
              <div className="title">
                <Heading text="We are here to help." />
              </div>
              <div>
                <div className="col-sm-6">
                  <div className="cell call-assistance">
                    Calling your previous institution during the rollover
                    process can be tricky. A member from our rollover assistance
                    team will help you by calling them with you.
                  </div>
                </div>
                <div className="col-sm-6">
                  <a
                    href={rolloverGuideTimeTradeLink}
                    data-name="rolloverGuideTimeTradeLink"
                    id="scheduleCallLink"
                    target="_blank"
                    rel="noopener noreferrer">
                    <div className="cell">
                      <div>Schedule the institution call.</div>
                      <div>Call takes approx. 30 minutes</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-container">
          <MFBeaconButton
            variant="secondary"
            size="normal"
            id="rolloverGuideBack"
            onClick={back()}
            label="Back"
          />
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default RolloverGuideScreen;
